/** Pure calendar helpers for the shopping cart assistant (no React). */

export function getDaysInMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

export function getFirstDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
}

export function isDateInRange(
  date: Date,
  selectedStartDate: Date | null,
  selectedEndDate: Date | null
): boolean {
  if (!selectedStartDate || !selectedEndDate) return false;
  const dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const start = new Date(
    selectedStartDate.getFullYear(),
    selectedStartDate.getMonth(),
    selectedStartDate.getDate()
  );
  const end = new Date(
    selectedEndDate.getFullYear(),
    selectedEndDate.getMonth(),
    selectedEndDate.getDate()
  );
  return dateStart >= start && dateStart <= end;
}

export function isDateSelectable(date: Date, minYear = 2026, maxYear = 2027): boolean {
  const year = date.getFullYear();
  return year >= minYear && year <= maxYear;
}

/** First day of “today’s” month, clamped into the bookable year window. */
export function defaultBookableMonth(
  now: Date = new Date(),
  minYear = 2026,
  maxYear = 2027,
): Date {
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const min = new Date(minYear, 0, 1);
  const max = new Date(maxYear, 11, 1);
  if (monthStart < min) return min;
  if (monthStart > max) return max;
  return monthStart;
}

/** Empty leading cells + day numbers 1..daysInMonth (null = padding). */
export function buildMonthDayCells(daysInMonth: number, firstDay: number): Array<number | null> {
  const cells: Array<number | null> = [];
  for (let i = 0; i < firstDay; i++) {
    cells.push(null);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    cells.push(day);
  }
  return cells;
}
